import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "special-stat-wrapper"
}
const _hoisted_2 = ["onMouseover"]
const _hoisted_3 = { class: "implant-btn-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "special-container",
    title: "SPECIAL"
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "special-stat-wrapper" }, [
        _createElementVNode("div", { class: "special-stat-headers" }, [
          _createElementVNode("div", { class: "special-stat-headers-drugs" }, " IMPLANTS "),
          _createElementVNode("div", { class: "special-stat-headers-base" }, " BASE "),
          _createElementVNode("div", { class: "special-stat-headers-drugs" }, " DRUGS ")
        ])
      ], -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.SPECIAL), (stat) => {
        return (_openBlock(), _createElementBlock("div", {
          key: stat,
          class: "special-stat-row"
        }, [
          (stat !== 'PL')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: "special-stat-name",
                  onMouseover: ($event: any) => (_ctx.showInfo('SPECIAL', stat))
                }, _toDisplayString(_ctx.SPECIAL[stat].name), 41, _hoisted_2),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_GenericButton, {
                    class: "implant-btn",
                    onClick: ($event: any) => (_ctx.implantSPECIAL(stat)),
                    "is-active": _ctx.isImplanted(stat),
                    "is-disabled": !_ctx.isImplantAvailable(stat),
                    onMouseover: ($event: any) => (_ctx.showInfo('Implants', stat)),
                    "image-src": require('@/assets/img/implants/special-implant.png'),
                    width: "45px",
                    height: "28px"
                  }, null, 8, ["onClick", "is-active", "is-disabled", "onMouseover", "image-src"])
                ]),
                _createElementVNode("div", {
                  class: "special-stat-value",
                  style: _normalizeStyle(_ctx.isImplanted(stat) ? 'color: #d7ffa6;' : '')
                }, _toDisplayString(_ctx.state.build.SPECIAL[stat].value), 5),
                _createElementVNode("div", {
                  class: "special-stat-value",
                  style: _normalizeStyle(_ctx.getColor(stat))
                }, _toDisplayString(_ctx.state.build.SPECIAL[stat].onDrugs), 5)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _: 1
  }))
}